import { invokeApi } from "../../bl_libs/invokeApi";

export const update_user_region_api = async (data) => {
  const requestObj = {
    path: `api/general_routes/update_user_region`,
    method: "POST",
    postData: data,
  };
  return invokeApi(requestObj);
};

export const open_ai_api = async () => {
  const requestObj = {
    path: `api/open_ai`,
    method: "GET",
  };
  return invokeApi(requestObj);
};
